<template>
    <form
        class="pt-8 lg:justify-between justify-start lg:items-center gap-2 flex w-full lg:flex-row flex-col"
    >
        <SearchBar formClass="p-0" :loading="loading" :showCloseButton="false">
            <template #inputs>
                <UiInput
                    name="favorites-search"
                    label="Search favorite airports"
                    id="favorites-search"
                    placeholder="Search by airport code or city"
                    :options="{
                        debounceTime: 500,
                        hideLabel: true,
                        inputClass:
                            'px-4 py-2 min-w-80 border border-slate-200 dark:border-slate-700 text-slate-500 dark:text-slate-400 placeholder:text-slate-500 dark:text-slate-400 placeholder:text-sm placeholder:font-light transition-colors focus:ring-0 focus:border-slate-800  disabled:opacity-50 disabled:cursor-not-allowed',
                        icon: 'search',
                        labelInputWrapperClass: 'w-80',
                    }"
                    @onInput="handleSearch"
                    inputClass=""
                />
            </template>
        </SearchBar>

        <div
            class="sm:justify-end justify-between items-center gap-6 flex mt-2 sm:mt-0"
        >
            <!-- START GROUP DROPDOWN -->
            <Transition name="fade" mode="out-in">
                <UiSingleSelect
                    v-if="activeFavoritesTab === 'Lounges'"
                    :options="groupingOptions"
                    v-model="localGroupBy"
                    label="Group"
                    buttonClass="gap-2 flex rounded-lg border-2 border-transparent text-slate-800 dark:text-slate-100 dark:text-slate-200 text-sm font-medium leading-tight items-center max-sm:focus:ring-2 max-sm:focus:ring-slate-300 focus:outline-none active:outline-none focus:border-slate-300 dark:focus:border-slate-600"
                    @changed="handleGroupingChange"
                >
                    <template #icon-left><Icon icon="groups" /></template>
                </UiSingleSelect>
            </Transition>
            <!-- END GROUP DROPDOWN -->
            <!-- START MAP BTN -->
            <button
                class="gap-2 flex rounded-lg border-2 border-transparent text-slate-800 dark:text-slate-100 dark:text-slate-200 text-sm font-medium leading-tight items-center max-sm:focus:ring-2 max-sm:focus:ring-slate-300 focus:outline-none active:outline-none focus:border-slate-300 dark:focus:border-slate-600 cursor-pointer order-last sm:order-none"
                type="button"
                @click.prevent="handleOpenMap"
                id="hs-lounge-favorites-map-btn"
            >
                <div class="w-5 h-5 flex items-center justify-center">
                    <Icon icon="map" />
                </div>
                <div class="text-slate-800 dark:text-slate-100 dark:text-slate-200 text-sm font-medium leading-tight">
                    Open Map View
                </div>
            </button>
            <!-- END MAP BTN -->
            <!-- START SORT DROPDOWN -->
            <UiSingleSelect
                :options="sortOptions"
                v-model="sortBy"
                label="Sort"
                buttonClass="gap-2 flex rounded-lg border-2 border-transparent text-slate-800 dark:text-slate-100 dark:text-slate-200 text-sm font-medium leading-tight items-center max-sm:focus:ring-2 max-sm:focus:ring-slate-300 focus:outline-none active:outline-none focus:border-slate-300 dark:focus:border-slate-600"
                dropdownClass="absolute right-0 mt-1 border border-slate-200 dark:border-slate-700 shadow-sm dark:shadow-slate-900/50 rounded-lg bg-white dark:bg-slate-800 z-10"
                @changed="handleSortChange"
            >
                <template #icon-left><Icon icon="sort" /></template>
            </UiSingleSelect>
            <!-- END SORT DROPDOWN -->
        </div>
    </form>
</template>

<script setup>
import { ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useLoungesStore } from '@/store/lounges';
import Icon from '@/components/ui/icon/icon.vue';
import SearchBar from '@/components/ui/inputs/search-bar/search-bar.vue';
import UiInput from '@/components/ui/inputs/ui-input.vue';
import UiSingleSelect from '@/components/ui/inputs/single-select/ui-single-select.vue';
const loungesStore = useLoungesStore();
const {
    setFavoritesSearchTerm,
    setGroupBy,
    setMapType,
    setShowMap,
    setSortBy,
} = loungesStore;
const { activeFavoritesTab, groupBy, loading, showMap } =
    storeToRefs(loungesStore);
const emit = defineEmits(['groupingChange']);
const localGroupBy = ref(null);
const sortBy = ref({});

const sortOptions = [
    { label: 'Default Sort', value: null },
    {
        label: 'Name A to Z',
        value: 'name',
    },
    {
        label: 'Name Z to A',
        value: '-name',
    },
    {
        label: 'Date Added - Oldest First',
        value: 'favorited_at',
    },
    {
        label: 'Date Added - Newest First',
        value: '-favorited_at',
    },
];

const groupingOptions = [
    { value: 'country', label: 'Country' },
    { value: 'name', label: 'Airport' },
];

const handleGroupingChange = () => {
    setGroupBy(localGroupBy.value);

    emit('groupingChange', localGroupBy.value);
};

const handleOpenMap = () => {
    if (activeFavoritesTab.value === 'Lounges') {
        setMapType('favoriteLounges');
    } else {
        setMapType('favoriteAirports');
    }
    setShowMap(true);
};

const handleSortChange = () => {
    setSortBy(sortBy.value);
};

const handleSearch = (s) => {
    setFavoritesSearchTerm(s.value);
};

watch(
    () => groupBy.value,
    (newVal) => {
        localGroupBy.value = newVal;
    }
);
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.15s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
